import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import DefaultButton from '../../../../../../global/default-button/default-button';
import { IHubRegistrationField } from '../../../../../../../api/hub-registration-configuration.dao';
import { EDIT_TEXT } from '../../../../../../../constants/common-labels.constants';
import { HubRegistrationSettingsVM } from './hub-registration-settings.viewmodel';
import './hub-registration-field-row.scss';

type HubRegistrationFieldRowProps = {
    field: IHubRegistrationField;
    vm: HubRegistrationSettingsVM;
    isEditing?: boolean;
};

export const HubRegistrationFieldRow: React.FC<HubRegistrationFieldRowProps> = observer(({ field, vm, isEditing }) => {
    return (
        <div
            className={classnames('hub-registration-field-row', {
                'hub-registration-field-row--active': isEditing,
            })}
        >
            <span className='hub-registration-field-row__label'>{field.label}</span>
            <div className='hub-registration-field-row__actions'>
                <DefaultButton
                    modifier='slim'
                    className='hub-registration-field-row__edit-button'
                    text={<FormattedMessage {...EDIT_TEXT} />}
                    onClick={() => vm.openFieldEditor(field)}
                />
            </div>
        </div>
    );
});
